/* eslint-disable lines-around-comment */
import { makeStyles } from '@material-ui/styles';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
// @ts-ignore
import { createBreakoutRoomsEvent, sendAnalytics } from '../../../../../analytics';
import Button from '../../../../../base/ui/components/web/Button';
// @ts-ignore
import { moveToRoom } from '../../../../../breakout-rooms/actions';
const useStyles = makeStyles((theme) => {
    return {
        button: {
            marginRight: `${theme.spacing(2)}px`
        }
    };
});
const JoinActionButton = ({ room }) => {
    const styles = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onJoinRoom = useCallback(e => {
        e.stopPropagation();
        sendAnalytics(createBreakoutRoomsEvent('join'));
        dispatch(moveToRoom(room.jid));
    }, [dispatch, room]);
    return (React.createElement(Button, { accessibilityLabel: t('breakoutRooms.actions.join'), className: styles.button, label: t('breakoutRooms.actions.join'), onClick: onJoinRoom, size: 'small', testId: `join-room-${room.id}` }));
};
export default JoinActionButton;
